import _ from 'lodash';
import Link from 'next/link';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import MaxWidthContainer from 'components/MaxWidthContainer';
import WebpImg from 'components/WebpImg';
import { getProductWebpImageUrl } from 'utils';

const { useRef, useEffect, useState } = React;

const NewReviewsInfiniteLoop = ({
  reviews = [],
  direction = 'left',
  speed = 30,
}) => {
  const infiniteRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const infiniteContainer = infiniteRef.current;
    if (!infiniteContainer || reviews.length === 0) return;
    let scrollAmount = 1; // Adjust the scroll step size
    const scroll = () => {
      if (!isHovered) {
        if (direction === 'left') {
          infiniteContainer.scrollLeft += scrollAmount;
          if (
            infiniteContainer.scrollLeft >=
            infiniteContainer.scrollWidth / 2
          ) {
            infiniteContainer.scrollLeft = 0;
          }
        } else {
          infiniteContainer.scrollLeft -= scrollAmount;
          if (infiniteContainer.scrollLeft <= 0) {
            infiniteContainer.scrollLeft = infiniteContainer.scrollWidth / 2;
          }
        }
      }
    };
    const interval = setInterval(scroll, speed);
    return () => clearInterval(interval);
  }, [isHovered, direction, speed, reviews]);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <div
      ref={infiniteRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="relative h-[133px] w-full overflow-hidden whitespace-nowrap"
      // style={{ width: '100%', height: '200px' }} // Adjust height as needed
    >
      {[...reviews, ...reviews].map((review, index) => {
        const productId = _.get(review, 'products.id');
        const productImageUrl = getProductWebpImageUrl(
          _.get(review, 'products.images.0')
        );
        // _.get(review, 'product.images.0.url') ||
        // '/images/placeholders/product.png';
        // console.log({ productImageUrl });
        const maskName = _.get(review, 'mask_name');
        const sorraUserPicture = _.get(review, 'sorra_user.picture');
        const comment = _.get(review, 'comment');
        const score = _.get(review, 'score');
        const scoreText = score === 1 ? '❤️' : score === -1 ? '👿' : '👌';
        const productName = _.get(review, 'products.name');
        const brandName = _.get(review, 'products.brand.name');

        return (
          <Link
            key={index}
            href={`/product/${productId}`}
            className="mx-2.5 inline-block h-full w-[240px] rounded-2xl bg-[#f5f5f5] p-3"
          >
            <div className="w-ful flex h-full flex-col gap-y-3">
              <div className="flex gap-x-2">
                <WebpImg
                  width={40}
                  src={productImageUrl}
                  className="h-15 w-15 shrink-0 overflow-hidden rounded-lg border border-sorra-gray-100 bg-white object-contain"
                />
                <div className="flex min-w-0 grow flex-col">
                  <div className="flex w-full min-w-0 items-center gap-x-1">
                    <div className="h-5 w-5 shrink-0">
                      {sorraUserPicture ? (
                        <img
                          className="h-full w-full rounded-full object-cover"
                          src={sorraUserPicture}
                        />
                      ) : (
                        <div className="flex h-full w-full items-center justify-center rounded-full bg-[#D6DDFB80] text-[10px] text-sorra-blue">
                          {`${maskName.charAt(0)}${maskName.charAt(
                            maskName.length - 1
                          )}`}
                        </div>
                      )}
                    </div>
                    <div className="grow truncate text-xs text-[#9B9B9B]">
                      {maskName}
                    </div>
                    <div className="-ml-0.5 -mt-1.5 shrink-0 text-base font-bold">
                      {scoreText}
                    </div>
                  </div>
                  <div className="mt-auto">
                    <p className="truncate text-[10px] text-[#4a4a4a]">
                      {brandName}
                    </p>
                    <p className="truncate text-xs font-bold">{productName}</p>
                  </div>
                </div>
              </div>
              <div className="grow text-xs text-[#111928]">
                <p className="line-clamp-2 text-wrap break-all">{comment}</p>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

const HomeNewReviews = (props) => {
  const { isLoading = false, reviews = [], speed = 30 } = props;
  const chunkReviews = _.chunk(reviews, reviews.length / 2);

  return (
    <MaxWidthContainer className="relative" noPending>
      {(isLoading || reviews.length > 0) &&
        (isLoading ? (
          <div className="h-[282px] overflow-hidden rounded-lg lg:h-[290px]">
            <Skeleton className="h-full w-full" />
          </div>
        ) : (
          <div className="relative flex flex-col gap-y-4 lg:gap-y-6">
            <NewReviewsInfiniteLoop
              isLoading={isLoading}
              reviews={chunkReviews[0]}
              speed={speed}
              direction="left"
            />

            <NewReviewsInfiniteLoop
              isLoading={isLoading}
              reviews={chunkReviews[1]}
              speed={speed}
              direction="right"
            />

            <div
              style={{
                background: `linear-gradient(to right, white 0%, transparent 10%), linear-gradient(to left, white 0%, transparent 10%)`,
              }}
              className="pointer-events-none absolute left-0 top-0 z-10 hidden h-full w-full lg:block"
            />
          </div>
        ))}
    </MaxWidthContainer>
  );
};

export default HomeNewReviews;
